// Applies a discount code from the cart drawer.
//
// Shopify has no AJAX endpoint for this. /discount/CODE applies a code to the live cart, and
// redirecting it to /cart.js makes the same request hand back the resulting cart — so one call
// both applies and verifies. Without the redirect it lands on the home page and returns ~60 KB
// of HTML that would only be thrown away.
//
// The response cannot say whether the code was any good: a nonsense code answers 200 exactly
// like a real one. Validity is read from the cart that comes back. A valid code can also fail to
// apply because a better discount is already on the cart, which is worth its own message — that
// case is recognised by a discount already being present before the attempt.
(function () {
  const BLOCK = '[data-promo]';
  const MESSAGE_MS = 3000;

  function codesInCart(cart) {
    const titles = (cart.cart_level_discount_applications || []).map((d) => d.title);
    (cart.items || []).forEach((item) => {
      (item.discounts || []).forEach((d) => titles.push(d.title));
    });
    // a code can be filed both cart-level and line-level, and would otherwise show up twice
    return [...new Set(titles.map((title) => String(title).toUpperCase()))];
  }

  function say(block, key) {
    const message = block.querySelector('[data-promo-message]');
    if (!message) return;
    message.textContent = (key && window.theme && theme.strings && theme.strings[key]) || '';
    message.hidden = !message.textContent;

    // a message outlives its moment: gone after 3s, and a newer one restarts the clock
    clearTimeout(message.promoTimer);
    if (message.textContent) {
      message.promoTimer = setTimeout(() => say(block, null), MESSAGE_MS);
    }
  }

  async function apply(block) {
    const input = block.querySelector('[data-promo-input]');
    const button = block.querySelector('[data-promo-apply]');
    const code = (input.value || '').trim();

    if (!code || block.hasAttribute('data-promo-busy')) return;

    block.setAttribute('data-promo-busy', '');
    button.disabled = true;

    const before = await fetch('/cart.js').then((r) => r.json());
    const hadDiscount = before.total_discount > 0;

    let after;
    let reached = true;
    try {
      const response = await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
        credentials: 'same-origin',
      });
      reached = response.ok;
      after = await response.clone().json();
    } catch (e) {
      after = await fetch('/cart.js').then((r) => r.json());
    }

    if (!reached) {
      // `shopify theme dev` answers 401 here: it proxies /discount/ straight to Shopify without
      // the session, so a code can only be tried on a real storefront URL. Worth saying out loud,
      // because the cart looks untouched and the code gets the blame.
      console.warn(
        '[promo] /discount/ did not answer. On `shopify theme dev` this route returns 401 — ' +
          'use the development theme’s own preview URL on the storefront instead.'
      );
    }

    // Two ways to know it worked. Normally the code names itself among the cart's discounts, but
    // a code can also combine with discounts already there, or be filed under its parent
    // discount's name rather than the code — so a larger discount than before also counts.
    const named = codesInCart(after).includes(code.toUpperCase());
    const deeper = after.total_discount > before.total_discount;

    // cleared whatever the outcome: a code that landed shows in its row below, one that failed in the message
    input.value = '';

    if (named || deeper) {
      // the discount row below says it landed, so a message as well would only repeat it
      say(block, null);
    } else if (hadDiscount) {
      say(block, 'promoBetterExists');
    } else {
      say(block, 'promoFailed');
    }

    // Applying changes the cart server-side but redraws nothing; the theme's own rebuild redraws
    // the discount rows along with everything else
    const cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getCart === 'function') cartItems.getCart();

    block.removeAttribute('data-promo-busy');
    button.disabled = false;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-promo-apply]');
    if (!button) return;
    event.preventDefault();
    apply(button.closest(BLOCK));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest('[data-promo-input]');
    if (!input) return;
    event.preventDefault();
    apply(input.closest(BLOCK));
  });
})();
